export const FONTS: string[] = [
  "Poppins",
  "Bebas Neue",
  "Roboto Slab",
  "Lora",
  "Bangers",
  "Knewave",
  "Short Stack",
  "Bruno Ace",
  "Libre Caslon Text",
  "Climate Crisis",
  "Sedgwick Ave Display",
  "Lobster",
  "Pacifico",
  "Sigmar",
];

export const BASE_API_URL = process.env.VUE_APP_BASE_API_URL;
export const REXQO_APP_ID = process.env.VUE_APP_REXQO_APP_ID;
export const CART_SLUG = process.env.VUE_APP_CART_SLUG||'cart/'
export const MAX_FILE_SIZE_MB = 15; 
export const COLORS: string[] = [
  "#FFFFFF",
  "#f1c40f",
  "#e67e22",
  "#d35400",
  "#c0392b",
  "#27ae60",
  "#3498db",
  "#8e44ad",
  "#2c3e50"
];

export enum ThemeColors {
  Primary = "#6563FF",
  White = "#FFFFFF",
  Darker = "#0D0D0D",
  Dark = "#1C1C1C",
  Black = "#000000",
  Transparent = "#00000000",
}

export const DEFAULT_PRODUCT_ID = "1227";
export const SHOW_DEBUG_TOOLS = false;
export const EMOJI_COUNT = 1799;
export const S3_BUCKET = "https://product-configurator-assets.s3.eu-central-1.amazonaws.com/";
export const SHOP_PAGE_PATH = 'personalizza';
export const DEFAULT_LANG = "it";
export const STORE_URL = process.env.VUE_APP_STORE_URL;
export const CONFIGURATOR_PAGE_SLUG = 'product-configurator';
export const WC_ENDPOINT = `${STORE_URL}/wp-admin/admin-ajax.php`;
export const ADD_TO_CART_ACTION = "add_to_cart";
export const GET_LOCALE_ACTION = "get_configurator_locale";
export const CONFIGURATOR_HISTORY_SIZE = 30;
export const LOGO_URL = S3_BUCKET+"logo.png";
export const LANGUAGES = ['en','fr','es', 'de'];
export const COLOR_WHEEL_URL =
S3_BUCKET+"color-wheel.png";
export const COLORS_ICON_URL =
S3_BUCKET+"color-icon.png";
export const WATERMARK_URL = S3_BUCKET+"watermark.png"
export const RED_BAR_URL =
S3_BUCKET+"red-bar.png";
